/**
 * src/shell/assets/manifest.ts — 资产清单（设计稿 §4.5 配套机制 1/2）。
 *
 * 底图已接入（v2，2026-08-15 制作人指定 docs/art/cockpit-base-v2.png，
 * 去水印净图存档 cockpit-base-v2-clean.png，接入产物 web/public/assets/cockpit-base.webp）。
 * 换图 = 换文件 + 改本清单（可 diff、可回滚），代码只读本清单。
 * 坐标为百分比（与底图分辨率解耦），origin 为驾驶舱容器左上角。
 */

export interface Anchor {
  /** 百分比坐标（0–100） */
  x: number
  y: number
  w: number
  h: number
}

export interface AssetManifest {
  compositionVersion: number
  /** 底图路径（灰盒期为空 = 无底图，纯代码场景） */
  baseImage: string | null
  desk: {
    /** 最左：办公电脑（热区） */
    computer: Anchor
    /** 电脑屏幕区（状态微光覆盖层） */
    computerScreen: Anchor
    /** 中间：文件堆（热区 + 纸堆覆盖层锚点） */
    papers: Anchor
    /** 右侧：老式电话（热区） */
    phone: Anchor
    /** 电话提示灯（呼吸灯覆盖层锚点） */
    phoneLamp: Anchor
    /** 最右角落：游戏卡带架（热区 + 卡带排布区） */
    shelf: Anchor
  }
}

/**
 * 构图 v2：按 cockpit-base-v2（2048×1152）实测校准。
 * 四物件左到右互不重叠：电脑 5–36.5 / 文件托盘 38–60 / 电话 61–83 / 卡带架 85.5–99。
 */
export const MANIFEST: AssetManifest = {
  compositionVersion: 2,
  baseImage: '/assets/cockpit-base.webp',
  desk: {
    computer: { x: 5, y: 29, w: 31.5, h: 56 },
    computerScreen: { x: 10.2, y: 35, w: 16.5, h: 22.5 },
    papers: { x: 38, y: 58.5, w: 22, h: 23.5 },
    phone: { x: 61, y: 51, w: 22, h: 26.5 },
    phoneLamp: { x: 73.2, y: 72.8, w: 2.2, h: 3.2 },
    shelf: { x: 85.5, y: 29, w: 13.5, h: 52.5 },
  },
}
